"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cicerale": {
    "67e33321": [{
      "hkey": "f0266b49",
      "slug": "cicerale",
      "name": "Cicerale",
      "primary": true,
      "skipSearch": false
    }],
    "monte-cicerale": [{
      "hkey": "f0266b49",
      "slug": "cicerale",
      "name": "Cicerale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "45a16905": [{
      "hkey": "f0266b49",
      "slug": "cicerale",
      "name": "Cicerale",
      "primary": true,
      "skipSearch": false
    }],
    "san-felice": [{
      "hkey": "f0266b49",
      "slug": "cicerale",
      "name": "Cicerale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;